import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeRepairRequestCreate } from './serialize';

/**
 * 建立報修單草稿。
 * POST `/aftersales/repair-request` → 201。
 * body 含 `repairRequestNo`（自 next-no 或使用者編輯）；**不送** reservationId。
 *
 * @param {object} payload camelCase
 */
export async function createRepairRequest(payload) {
  const { data: raw } = await request.post(
    '/aftersales/repair-request',
    serializeRepairRequestCreate(payload),
  );
  return parseVer4DetailResponse(raw);
}
